import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export const visitSlice = createSlice({
  name: 'visit',
  initialState,
  reducers: {
    getVisits: (state) => {
      state.loading = true;
    },
    likeVisit: (state) => {
      // Like doesn't necessarily need a loading state for the whole list
    },
    successVisit: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedVisit: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getVisits,
  likeVisit,
  successVisit,
  failedVisit,
} = visitSlice.actions;

export default visitSlice.reducer;
